import React from 'react';
import PropTypes from 'prop-types';
import { List, Map } from 'immutable';
import { injectIntl, useIntl } from 'react-intl';
import { connect } from 'react-redux';
import appConfig from '../../appConfig';
import PanelTree from '../PanelTree';
import { validateSessionConnection } from '../../actions/session';
import {
  getLabelFromAppConfig,
  showAuthWorkflowTemplate,
  showWorkflowDashTemplate,
  showMetaEditTool,
  showUsersAndRolesScreen,
  showManageCatRolesScreen,
  showNewRecordTool,
} from '../../utils/uiUtils';
import { showLocalAdminAsMain } from '../../actions/mainUI';
import {
  ADMIN_PUBLISH,
} from '../../constants/mainContentTypes';

const OPTION_AUTHWORKFLOW = 'AUTHWORKFLOW';
const OPTION_WORKFLOWDASH = 'WORKFLOWDASH';
const OPTION_METAATTACH = 'OPTION_METAATTACH';
const OPTION_USERSANDROLES = 'OPTION_USERSANDROLES';
const OPTION_MANAGECATEGORYROLES = 'OPTION_MANAGECATEGORYROLES';
const OPTION_PUBLISH = 'OPTION_PUBLISH';
const OPTION_CREATERELATIONAL = 'OPTION_CREATERELATIONAL';

const mapDispatchToProps = dispatch => ({
  dispatch: actionToDispatch => dispatch(actionToDispatch),
  validateSession: surl => dispatch(validateSessionConnection(surl)),
  showPublishAdminScreen: () => dispatch(showLocalAdminAsMain(ADMIN_PUBLISH)),
});

const mapStateToProps = state => ({
  session: state.session,
});

const NavAdminPanel = ({
  dispatch, session, validateSession, showPublishAdminScreen,
}) => {
  let optionsList;
  const intl = useIntl();
  if (appConfig.menuOptions &&
    appConfig.menuOptions.adminMenu &&
    appConfig.menuOptions.adminMenu.length > 0) {
    const adminMenu = appConfig.menuOptions.adminMenu;
    optionsList = new List();

    adminMenu.forEach((value) => {
      switch (value) {
        case 'auth':
          optionsList = optionsList.push(new Map({
            i: OPTION_AUTHWORKFLOW,
            n: getLabelFromAppConfig(appConfig.templates.authoriseWorkflow, intl.locale),
            hideIcon: true,
          }));
          break;
        case 'workflowDash':
          optionsList = optionsList.push(new Map({
            i: OPTION_WORKFLOWDASH,
            n: getLabelFromAppConfig(appConfig.templates.workflowDashboard, intl.locale),
            hideIcon: true,
          }));
          break;
        case 'metaAttach':
          optionsList = optionsList.push(new Map({
            i: OPTION_METAATTACH,
            n: intl.formatMessage({ id: 'navAdminPanel.metaAttach' }),
            hideIcon: true,
          }));
          break;
        case 'usersAndRoles':
          optionsList = optionsList.push(new Map({
            i: OPTION_USERSANDROLES,
            n: intl.formatMessage({ id: 'navAdminPanel.usersAndRoles' }),
            hideIcon: true,
          }));
          break;
        case 'manageCategoryRoles':
          optionsList = optionsList.push(new Map({
            i: OPTION_MANAGECATEGORYROLES,
            n: intl.formatMessage({ id: 'navAdminPanel.manageCategoryRoles' }),
            hideIcon: true,
          }));
          break;
        case 'publish':
          optionsList = optionsList.push(new Map({
            i: OPTION_PUBLISH,
            n: intl.formatMessage({ id: 'navAdminPanel.publishBtn' }),
            hideIcon: true,
          }));
          break;
        case 'newRelational':
          optionsList = optionsList.push(new Map({
            i: OPTION_CREATERELATIONAL,
            n: intl.formatMessage({ id: 'navAdminPanel.createRelationalBtn' }),
            hideIcon: true,
          }));
          break;
        default:
          break;
      }
    });
  }

  const onPanelItemClick = (key) => {
    const surl = session ? session.get('surl') : sessionStorage.surl;
    validateSession(surl).then((res) => {
      if (res.isValid) {
        switch (key) {
          case OPTION_AUTHWORKFLOW:
            showAuthWorkflowTemplate(dispatch, session.get('locale'));
            break;
          case OPTION_METAATTACH:
            showMetaEditTool(null, dispatch);
            break;
          case OPTION_WORKFLOWDASH:
            showWorkflowDashTemplate(dispatch, session.get('locale'));
            break;
          case OPTION_USERSANDROLES:
            showUsersAndRolesScreen(dispatch, session.get('locale'));
            break;
          case OPTION_MANAGECATEGORYROLES:
            showManageCatRolesScreen(dispatch, appConfig.restrictEditing);
            break;
          case OPTION_PUBLISH:
            showPublishAdminScreen();
            break;
          case OPTION_CREATERELATIONAL:
            showNewRecordTool(dispatch);
            break;
          default: break;
        }
      }
    });
  };

  return (
    <div className="nav-content__body">
      <h2 className="nav-content__title">{intl.formatMessage({ id: 'navAdminPanel.adminHeader' })}</h2>
      <PanelTree
        onPanelItemClick={onPanelItemClick}
        panelTreeList={optionsList}
        isRoot
      />
    </div>
  );
};

NavAdminPanel.propTypes = {
  dispatch: PropTypes.func,
  session: PropTypes.instanceOf(Map),
  validateSession: PropTypes.func,
  showPublishAdminScreen: PropTypes.func,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(NavAdminPanel));



// WEBPACK FOOTER //
// ./src/js/components/NavAdminPanel/index.jsx